export default "__VITE_ASSET__ClfhdY9g__"